import { render, staticRenderFns } from "./issueClarificationNotice.vue?vue&type=template&id=3e39cf76&scoped=true"
import script from "./issueClarificationNotice.vue?vue&type=script&lang=js"
export * from "./issueClarificationNotice.vue?vue&type=script&lang=js"
import style0 from "./issueClarificationNotice.vue?vue&type=style&index=0&id=3e39cf76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e39cf76",
  null
  
)

export default component.exports